import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { DEFAULT_SHOPPING_CART, IShoppingCart } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { ShoppingCartGateway } from './shopping-cart.gateway';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartStore {
  private readonly gateway: ShoppingCartGateway = new ShoppingCartGateway();

  readonly #shoppingCartResource: ResourceRef<
    IApiResponse<IShoppingCart> | undefined
  > = resource({
    loader: (): Promise<IApiResponse<IShoppingCart>> => {
      return firstValueFrom(this.gateway.get());
    },
  });

  readonly isLoading: Signal<boolean> = computed(() =>
    this.#shoppingCartResource.isLoading()
  );
  readonly shoppingCart: Signal<IShoppingCart> = computed(
    (): IShoppingCart =>
      this.#shoppingCartResource.hasValue()
        ? (this.#shoppingCartResource.value()?.data ?? DEFAULT_SHOPPING_CART)
        : DEFAULT_SHOPPING_CART
  );

  updateShoppingCart(query: IShoppingCart): void {
    this.#shoppingCartResource.update((): IApiResponse<IShoppingCart> => {
      return {
        data: query,
      };
    });
  }

  save(query: IShoppingCart) {
    firstValueFrom(this.gateway.save(query)).then(
      (result: IApiResponse<IShoppingCart>) => {
        if (result && result.data) {
          this.updateShoppingCart(result.data);
        }
      }
    );
  }

  reload(): void {
    this.#shoppingCartResource.reload();
  }
}
